'use client';

import { Box, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';

export type CalculatorFieldProps = {
  children: ReactNode;
  error?: string | null;
  htmlFor: string;
  label: string;
  labelSx?: SxProps<Theme>;
  sx?: SxProps<Theme>;
};

export function CalculatorField({
  children,
  error,
  htmlFor,
  label,
  labelSx,
  sx,
}: CalculatorFieldProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.125rem',
        minWidth: 0,
        width: '100%',
        ...sx,
      }}
    >
      <Typography component="label" variant="textSmallBold" htmlFor={htmlFor} sx={labelSx}>
        {label}
      </Typography>
      {children}
      {error ? (
        <Typography variant="textExtraSmall" sx={{ color: 'reds.main' }}>
          {error}
        </Typography>
      ) : null}
    </Box>
  );
}
